import React, { Component, useState, useEffect, useRef } from 'react'
import Loader from '../Loader/Loader';
import Helper from '../Helper'
import useStateRef from 'react-usestateref';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { APPLICATION_JSON } from '../../middleware/types';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

function HostedCatalogFileExport({ containerObject, templateName, contentId, dataZone }) {

    const [hasError, setHasError, setHasErrorRef] = useStateRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isPriceListDisabled, setIsPriceListDisabled] = useState(false);

    const validateForm = (key, value) => {
        switch (key) {
            case "templateFormat":
                if (value === 'select') {
                    setHasError(true);
                    document.getElementById("error-message-div").classList.remove("d-none");
                    document.getElementById("error-message-div").classList.add("d-block");
                    document.getElementById("template_format").classList.add("form-error");
                    var invalidTemplateFormat = document.getElementById("templateFormat_error");
                    invalidTemplateFormat.innerHTML = "Template Format is a required field.";
                }
                break;
            case "priceList":
                var templateFormat = document.getElementById("template_format").value;
                if (value === 'select' && (templateFormat != 'JaggaerContentItem' || templateFormat != 'JaggaerMultiplePrices'
                	|| templateFormat != 'WestCoastUniversity' || templateFormat != 'BereaSchools' || templateFormat != 'PalmBeach' || templateFormat != 'Quartzy')) {
                    setHasError(true);
                    document.getElementById("error-message-div").classList.remove("d-none");
                    document.getElementById("error-message-div").classList.add("d-block");
                    document.getElementById("price_list").classList.add("form-error");
                    var invalidPriceList = document.getElementById("priceList_error");
                    invalidPriceList.innerHTML = "Price List is a required field.";
                }
                break;
            default:
        }
    }

    const clearErrorMsg = (e) => {
        document.getElementById("error-message-div").classList.add("d-none");
        document.getElementById("template_format").classList.remove("form-error");
        document.getElementById("price_list").classList.remove("form-error");
        document.getElementById("templateFormat_error").innerHTML = "";
        document.getElementById("priceList_error").innerHTML = "";
    }

    const handleTemplateFormatChange = (e) => {
        console.log("templateFormat: " + e.target.value)
        if((e.target.value === 'JaggaerContentItem'
                || e.target.value === 'JaggaerMultiplePrices' || e.target.value === 'WestCoastUniversity'
                	|| e.target.value === 'BereaSchools' || e.target.value === 'Quartzy' || e.target.value === 'PalmBeach')) {
            setIsPriceListDisabled(true);
            document.getElementById("price_list").value = "select";
        } else {
            setIsPriceListDisabled(false);
        }
    };


    const handleExportHostedCatalog = (event) => {
        event.preventDefault();
        clearErrorMsg();
        setHasError(false);
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        Object.entries(formValue).map(([key, value], keyIndex) => {
            validateForm(key, value)
        })
        console.log("setHasErrorRef.current..." + setHasErrorRef.current);
        if(!setHasErrorRef.current) {
            setIsLoading(true);
            var templateFormat = formData.get("templateFormat");
            var selectedPriceList = formData.get("priceList");
            var fileName;
            var queryParams = (selectedPriceList === 'select' || selectedPriceList == null) ? '' : '?priceList=' + selectedPriceList;
            var actionUrl = `api/v1/hosted-catalog/export/format/${templateFormat}${queryParams}`;
            var hostName = containerObject.hostNameForCatalogExport;
            fetch(`${hostName}/${actionUrl}`).then((res) => {
                console.log('res..', res);
                const disposition = res.headers.get('Content-Disposition');
                console.log('disposition..', disposition);
                if (disposition && disposition.includes('filename=')) {
                  fileName = disposition
                    .split('filename=')[1]
                    .replace(/["']/g, '')
                    .trim();
                }
                return res.blob();
           })
            .then((blob) => {
                setIsLoading(false);
                console.log('blob..', blob);
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', `${fileName}`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((err) => {
                setIsLoading(false);
                props.loaderStatusCallBackFunction(false)
                return Promise.reject({ Error: 'Something Went Wrong', err });
            })
        }
    }

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} >

            <div id="error-message-div" className="d-none alert alert-danger login-error-msg mx-2 form-error-messages" style={{ "margin-left": "2rem" }}>
                <div id="templateFormat_error"></div>
                <div id="priceList_error"></div>
            </div>

            <div class="row my-3 d-none d-md-block" style={{ "margin-left": "2rem" }}>
                <div class="col-6 col-md-6">
                    <h1 class="right-panel-heading">Hosted Catalog File Export</h1>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12" style={{ "margin-left": "2rem" }}>
                    {isLoading ? <Loader /> : ""}
                    <form method="post" autocomplete="off" onSubmit={handleExportHostedCatalog} id="update" class="c-account-page g-3" data-hs-cf-bound="true">
                        <div class="row">
                            <div class="col-md-5 mb-3">
                                <label for="templateFormat" class="form-label">Template Format</label>
                                <select name="templateFormat" id="template_format" className="form-select" onChange={handleTemplateFormatChange}>
                                    <option id="select" value="select">Select</option>
                                    <option id="Ariba" value="Ariba">Ariba</option>
                                    <option id="BereaSchools" value="BereaSchools">Berea Schools</option>
                                    <option id="EqualLevelPrices" value="EqualLevelPrices">Equal Level Prices</option>
                                    <option id="JaggaerContentItem" value="JaggaerContentItem">Jaggaer Content Item</option>
                                    <option id="JaggaerMultiplePrices" value="JaggaerMultiplePrices">Jaggaer Multiple Prices</option>
                                    <option id="PalmBeach" value="PalmBeach">Palm Beach</option>
                                    <option id="Quartzy" value="Quartzy">Quartzy</option>
                                    <option id="Unimarket" value="Unimarket">Unimarket</option>                                
                                    <option id="WestCoastUniversity" value="WestCoastUniversity">West Coast University</option>                                   
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 mb-3">
                                <label for="priceList" class="form-label">Price List</label>
                                <select name="priceList" id="price_list" className="form-select" disabled={isPriceListDisabled}>>
                                    <option id="select" value="select">Select</option>
                                    <option id="CBS" value="CBS">Carolina Biological Supply Default (CBS)</option>
                                    <option id="CBSSTD" value="CBSSTD">Carolina Biological Supply, 5% Discount (CBSSTD)</option>
                                    <option id="CBSSTT" value="CBSSTT">Carolina Biological Supply, 10% Discount (CBSSTT)</option>
                                    <option id="CONSTT" value="CONSTT">Carolina Biological Supply Contract, 10% Discount (CONSTT)</option>
									<option id="DELSTT" value="DELSTT">Delaware State Contract (DELSTT)</option>
                                    <option id="EDSEDS" value="EDSEDS">Educational Data Services (EDSEDS)</option>
                                    <option id="GASGAS" value="GASGAS">Georgia State Contract, 10% Discount (GASGAS)</option>
                                    <option id="MSSMSS" value="MSSMSS">Mississippi State Contract, 10% Discount (MSSMSS)</option>
                                    <option id="NCCNCC" value="NCCNCC">North Carolina State Contract (NCCNCC)</option>
                                    <option id="SCCSCC" value="SCCSCC">South Carolina State Contract, 10% Discount (SCCSCC)</option>
                                </select>
                            </div>
                        </div>
                        <div class="row g-3 mb-3">
                            <div class="col-md-5 d-grid">
                                <button type="submit" class="btn btn-primary block">Export</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default HostedCatalogFileExport